import { createFileRoute } from '@tanstack/react-router'

import { getTranslations } from '@/i18n/translator'
import { pageHead, SITE_URL } from '@/lib/seo'
import { breadcrumbSchema, homeBreadcrumbItem } from '@/lib/structured-data'
import { getPricingPlans } from '@/server/pricing'
import { CompliassistPricing } from '@/features/compliassist-pricing/components'
import { CheckoutStatusDialog } from '@/features/compliassist-pricing/components/checkout-status-dialog'
import { parsePricingSearch } from '@/features/compliassist-pricing/lib/pricing-search'

export const Route = createFileRoute(
  '/$locale/pricing',
)({
  validateSearch: parsePricingSearch,
  loader: async ({ params }) => {
    const t = await getTranslations({
      locale: params.locale,
      namespace: 'compliassist.pricing',
    })
    return {
      title: t('metaTitle'),
      description: t('metaDescription'),
      plans: await getPricingPlans(),
    }
  },
  head: ({ loaderData, params }) => {
    const path = '/pricing'
    const url = `${SITE_URL}/${params.locale}${path}`
    const title = loaderData?.title ?? ''
    const description = loaderData?.description ?? ''
    return pageHead({
      locale: params.locale,
      path,
      title,
      description,
      jsonLd: breadcrumbSchema([
        homeBreadcrumbItem(params.locale),
        { name: title, url },
      ]),
    })
  },
  component: Page,
})

function Page() {
  const { plans } = Route.useLoaderData()
  const { status, plan, cycle } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <>
      <CompliassistPricing plans={plans} />
      <CheckoutStatusDialog
        status={status}
        retry={plan && cycle ? { plan, cycle } : undefined}
        onClose={() =>
          navigate({
            search: (prev) => ({
              ...prev,
              status: undefined,
              plan: undefined,
              cycle: undefined,
            }),
            replace: true,
          })
        }
      />
    </>
  )
}
